import { Field, useFormikContext } from 'formik';
import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { DropdownWithValidation } from '../../components/prime-formik';
import AddBehaviorDimension from './AddBehaviorDimension';
import AddCognitiveDimension from './AddCognitiveDimension';

const i18nMessages = defineMessages({
  sectionName: {
    id: 'menu.item-bank-management.section-name',
    defaultMessage: 'Section Name',
  },
});

const AddDimension = ({ availableSections }) => {
  const { values } = useFormikContext();
  const { formatMessage } = useIntl();

  const sectionOptions = availableSections.map((section) => ({
    value: section.code,
    label: section.displayName,
  }));

  return (
    <>
      <div>
        <div className="input-label">{formatMessage(i18nMessages.sectionName)}</div>
        <div className="section-options">
          <Field id="section" name="section" component={DropdownWithValidation} options={sectionOptions} />
        </div>
      </div>
      {values.section === 'behavior' && <AddBehaviorDimension />}
      {values.section === 'cognitive' && <AddCognitiveDimension />}
    </>
  );
};

export default AddDimension;
